var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#939090",
    strokeWidth: 1.6,
    d: "M3.3 9.72754C3.3 6.1653 6.18776 3.27754 9.75 3.27754C13.3122 3.27754 16.2 6.1653 16.2 9.72754L16.2 16.1775L9.75 16.1775C6.18777 16.1775 3.3 13.2898 3.3 9.72754Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1.3,
    x: 6.25,
    y: 8.478,
    fill: "#939090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1.3,
    x: 7.75,
    y: 10.956,
    fill: "#939090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1c3eba35eeb0a0c8cc2bf7a369248309.svg";
export { ForwardRef as ReactComponent };